/* eslint-env browser */
/* eslint react/prop-types: 0 */
import 'react-activity/dist/react-activity.css';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';
import {login} from '../../actions/UserActions';
import * as validationTypes from '../../constants/ValidationConstants';
import {Link} from 'react-router-dom';
import LoginRedirectHandler from "./LoginRedirectHandler";
import Footer from "../footer/Footer";
import Title from "./Title";
import LoginLogo from "./LoginLogo";
import Logo from "../Logo";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
    };

    this.onLogin = this.onLogin.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  onLogin() {
    this.validateCredentials();
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.validateCredentials();
    }
  };

  validateCredentials() {
    if (this.state.email === null || this.state.password === null || this.state.email === '' || this.state.password === '') {
      toast.error(validationTypes.CREDENTIALS_REQUIRED, {position: toast.POSITION.TOP_RIGHT});
    } else {
      login(this.props.dispatch, this.state.email, this.state.password).then().catch((error) => {
       
      });
    }
  }

  handleOnChange = input => (e) => {
    this.setState({
      [input]: e.target.value,
    });
  };
  
  render() {
    let backgroundClasses = "";
    if(this.props.useBackground){
      backgroundClasses += " login-background"; 
    }
    
    return (
      <React.Fragment>
        <div className={backgroundClasses}>
          <div className={"row align-items-center login-row"}>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mx-auto login-area mt-3">
              <div className={"row"}>
                <div className={"mx-auto mt-3"}>
                  <LoginLogo width={200}/>
                </div>
              </div>
              <div className="row">
                <div className={"col"}>
                  <form action="" id="loginForm" onSubmit={this.handleSubmit} autoComplete={"off"}>
                    <h1 className="heading mt-3" align="center"><Title/></h1>
                    <br/>
                    <div className="form-group mt-3">
                      <input type="email" className="form-control control-border" name="email" placeholder="Email"
                             onKeyPress={this.handleKeyPress} onChange={this.handleOnChange('email')}/>
                    </div>
                    <div className="form-group">
                      <input type="password" className="form-control control-border" name="password" placeholder="Password"
                             onKeyPress={this.handleKeyPress} onChange={this.handleOnChange('password')}/>
                    </div>
                    <div className="form-group">
                      <button type="button"
                              className="btn btn-primary loginButtonColor form-control control-border button-class"
                              onClick={this.onLogin}>Log In
                      </button>
                    </div>
                    <div className="form-group text-center button-class">
                      <Link to={"/request-password-reset"}>
                        <span className="trouble">Having trouble logging in?</span>
                      </Link>
                    </div>
                    <br/>
                    <br/>
                    <div className="form-group">
                      <Link to={"/auto-register/accounts"}>
                        <button type="button"
                                className="btn btn-secondary registerButtonColor form-control control-border button-class">
                          <span className="register-button-text">Register</span>
                        </button>
                      </Link>
                    </div>
                  </form>
                </div>
                {this.props.isLoggedIn && <LoginRedirectHandler/>}
                <Footer/>
              </div>
            
            </div>
          </div>
          <div className={"logo-bottom-right"}>
            <Logo width={"80"} bottomLogin={true}/>
          </div> 
        </div>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect(store => ({
  documentsList: store.default.documentsList,
  customer_number: store.default.customer_number,
  company_code: store.default.company_code,
  sales_organization: store.default.sales_organization,
  isLoggedIn: store.user.isLoggedIn,
  useBackground: store.app.config.style.login_use_background_image,
}))(Login);
